module.exports = __webpack_public_path__ + "static/media/drag-city-landing.f562475e.jpg";